import { PreProcessor } from 'api/requestUtils'
import { AppStore } from 'src/client/store'
import qs from 'qs'

// This is a temporary fix until we decide to localize english.
const englishLocalesMap: { [key: string]: string } = {
  'en-US': 'en-AU',
  'en-CA': 'en-AU',
}

function getMappedLocales(locales: string[]): string[] {
  const localesSet = new Set<string>()
  locales.forEach((locale) => {
    localesSet.add(englishLocalesMap[locale] ?? locale)
  })
  return Array.from(localesSet)
}

export default function localesLoader(store: AppStore): PreProcessor {
  return (params) => {
    if (params.options?.locales === 'include') {
      const s = store.getState()
      if (s.config.locales.length) {
        let paramsPrefix = '?'
        if (params.path.endsWith('?')) {
          paramsPrefix = ''
        } else if (params.path.includes('?')) {
          paramsPrefix = '&'
        }

        const query = qs.stringify({ locales: getMappedLocales(s.config.locales) }, { arrayFormat: 'indices' })

        params.path += paramsPrefix + query

        delete params.options.locales
      }
    }
    return params
  }
}
